import { Button } from "@omni/ui/components/Button/button.component";
import { FlyoutButtonProps } from "@omni/ui/components/FlyoutButton/flyoutButton.props";
import { cn } from "@omni/utils/styles";

const FlyoutButton = ({ active = false, title, update }: FlyoutButtonProps) => {
    return (
        <div className={cn("tw:flex tw:h-full")}>
            <div className={cn("tw:relative tw:self-center")}>
                <Button
                    tabIndex={0}
                    color={"primary"}
                    onClick={update}
                >
                    <span className={cn("tw:whitespace-nowrap tw:select-none")}>
                        {title}
                        <i
                            className={cn(
                                "las la-angle-down",
                                "tw:m-0 tw:ml-1.5 tw:transition-transform tw-duration-100",
                                {
                                    "tw:-rotate-180": active
                                }
                            )}
                        />
                    </span>
                </Button>
            </div>
        </div>
    );
};

export { FlyoutButton };
